import { WifiOff, RotateCcw } from 'lucide-react';
import { RouterProvider } from 'react-router-dom';
import { router } from './router';
import { useSessionBootstrap } from './features/auth/hooks';
import { Spinner } from './shared/ui/Spinner';
import { Button } from './shared/ui/Button';

function AppWithBootstrap() {
  const { profileReady, bootstrapError, retryBootstrap } = useSessionBootstrap();

  if (bootstrapError) {
    return (
      <div className="flex h-screen items-center justify-center bg-bg px-6">
        <div className="w-full max-w-sm">
          {/* Icon */}
          <div className="mb-6 flex h-14 w-14 items-center justify-center rounded-2xl border border-danger/30 bg-danger-bg">
            <WifiOff size={22} className="text-danger" />
          </div>

          {/* Label */}
          <p className="mb-1 text-xs font-black uppercase tracking-widest text-danger">
            Connection error
          </p>

          {/* Heading */}
          <h1 className="mb-2 text-xl font-black text-text">
            Could not reach the server
          </h1>

          {/* Body */}
          <p className="mb-8 text-sm leading-relaxed text-muted">
            Check your internet connection and try again. If the problem persists, the server may be temporarily unavailable.
          </p>

          {/* CTA */}
          <Button
            variant="secondary"
            onClick={retryBootstrap}
            className="!font-black !text-text"
          >
            <RotateCcw size={13} />
            Try again
          </Button>
        </div>
      </div>
    );
  }

  if (!profileReady) {
    return (
      <div className="flex h-screen items-center justify-center bg-bg">
        <Spinner size="lg" />
      </div>
    );
  }

  return <RouterProvider router={router} />;
}

export default function App() {
  return <AppWithBootstrap />;
}
